import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hello, I would like to report an accident\n',
    },
    content: {
      days: 'days',
      exclude: {
        items: [
          'Accidents occurring as a result of professional sports practice;',
          'Accidents occurring as a result of drug use or medications obtained fraudulently or not prescribed by a competent medical authority.',
        ],
        title: 'This coverage does not include',
      },
      include: {
        items: [
          '€100 per day in case of hospitalization due to an accident, from the first day and up to {0} {1};',
          '€5,000 to your beneficiaries in case of death due to an accident.',
        ],
        title: 'This coverage includes',
      },
      nights: 'nights',
    },
    similarOffersTitle: 'Other related insurances',
    title: 'Hospitalization Insurance',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      days: 'jours',
      exclude: {
        items: [
          'Les accidents survenus suite à une pratique sportive professionnelle ;',
          "Les accidents survenus suite à l'usage de stupéfiants ou produits médicamenteux obtenus frauduleusement ou non prescrits par une autorité médicale compétente.",
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          "100 € par jour en cas d'hospitalisation suite à un accident, dès le premier jour et jusqu'à {0} {1};",
          '5 000 € à vos bénéficiaires en cas de décès suite à un accident.',
        ],
        title: 'Cette garantie inclut',
      },
      nights: 'nuits',
    },
    similarOffersTitle: 'Autres assurances liées',
    title: 'Assurance hospitalisation',
  },
} as const);

export default locales;
